import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const BlogGetList = createAsyncThunk(
  "BlogGetList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url: data?.url,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

const initialState = {
  BlogGetListData: {
    data: null,
    error: null,
  },
};

const WordpressSlice = createSlice({
  name: "WORDPRESS",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(BlogGetList.fulfilled, (state, action) => {
        state.BlogGetListData.data = action.payload;
      })
      .addCase(BlogGetList.rejected, (state, action) => {
        state.BlogGetListData.error = action.error.message;
      });
  },
});

export default WordpressSlice.reducer;
